export default [
    { //特惠推荐 （暂时没用）
        path: '/index/preferential',
        name: 'Preferential',
        component: () => import('@/views/index/Preferential.vue'),
        meta: {
            showTab: false
        }
    },
    { //品牌制造
        path: '/index/brand',
        name: 'Brand',
        component: () => import('@/views/index/Brand.vue'),
        meta: {
            showTab: false
        }
    },
]
